<template>
  <div class="row">
    <div class="col-md-12 pt-0 text-danger">
      Todas as informações são obrigatórias!
    </div>
    <div class="col-md-3 pt-0 pb-0">
      <v-select
        v-model="type"
        :items="[
          { value: 'DIARIA', description: 'DIÁRIA' },
          { value: 'MENSAL', description: 'MENSAL' },
        ]"
        label="PLANO"
        dense
        outlined
        item-value="value"
        item-text="description"
        @input="handleInputType"
      />
    </div>
    <div class="col-md-3 pt-0 pb-0">
      <v-text-field
        v-model="due_date"
        :label="
          type == 'DIARIA'
            ? 'Vencimento da mensalidade'
            : 'Vencimento da 1ª mensalidade'
        "
        outlined
        dense
        type="date"
        @input="handleInputDueDate"
      />
    </div>
    <div class="col-md-3 pt-0 pb-0">
      <v-text-field
        v-model="value"
        :label="type == 'DIARIA' ? 'Valor da diária' : 'Valor da mensalidade'"
        outlined
        dense
        @input="handleValueDaily"
      />
    </div>
    <div class="col-md-3 pt-0 pb-0" v-if="type == 'DIARIA'">
      <v-select
        v-model="daily_amount"
        :items="daily_amounts"
        label="Quantidade de diárias"
        dense
        outlined
        item-value="value"
        item-text="description"
        @change="handleValueDailyAmount"
      />
    </div>
    <div class="col-md-3 pt-0 pb-0" v-if="type == 'DIARIA'">
      <v-text-field
        disabled
        label="Total do período"
        :value="formatValueOnKeyUp(String(total_daily_value))"
        outlined
        dense
      />
    </div>
    <div class="col-md-3 pt-0 pb-0" v-if="type == 'MENSAL'">
      <v-select
        :disabled="!due_date || !value"
        v-model="number_of_installments"
        :items="parcel_numbers"
        label="Quantidade de parcelas"
        dense
        outlined
        item-value="value"
        item-text="description"
        @change="handleValueNumberOfInstallments"
      />
    </div>
    <div class="col-md-12 pt-0 pb-0" v-if="type == 'MENSAL'">
      <hr class="mt-0" v-if="items.length > 0" />
      <div class="row" v-for="(item, key) in items" :key="key">
        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            disabled
            label=""
            outlined
            dense
            type="text"
            :value="`${key + 1}ª PARCELA`"
          />
        </div>
        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            label="Vencimento"
            outlined
            dense
            type="date"
            v-model="item.due_date"
          />
        </div>
        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            label="Valor"
            outlined
            dense
            type="text"
            v-model="item.value"
            @input="item.value = formatValueOnKeyUp(String(item.value))"
          />
        </div>
        <div class="col-md-3 pt-0 pb-0">
          <v-text-field
            label="Observação"
            outlined
            dense
            type="text"
            v-model="item.note"
          />
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-0"><hr class="m-0" /></div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 pt-0 pb-0 text-right">
      <confirmation-dialog
        headerClass="modal-header-i"
        message-title="Deseja realmente lançar?"
        message-body=""
        openText="LANÇAR"
        open-class="btn-save"
        open-left-icon="fa-check"
        @yes="execute"
        :disabled="btnExecute || loadingExecute"
        :loading="loadingExecute"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import { formatValueOnKeyUp, numbersOnly } from "../../../../lib/format";

import moment from "moment";

export default {
  name: "New",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },

  computed: {
    btnExecute() {
      let { type, items, due_date, value } = this;

      if (!type) {
        return true;
      }

      if (type == "MENSAL") {
        if (items.length == 0) {
          return true;
        }

        for (let item of items) {
          if (!item.value || !item.due_date) {
            return true;
          }
        }
      }

      if (type == "DIARIA") {
        if (!due_date) {
          return true;
        }

        if (!value || value == "0,00") {
          return true;
        }
      }

      return false;
    },
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      type: "MENSAL",
      value: "",
      daily_amount: 1,
      daily_amounts: [],
      total_daily_value: 0,
      number_of_installments: "",
      parcel_numbers: [],
      due_date: "",

      data: [],

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "PLANO", value: "plan", sortable: false },
        { text: "INFORMAÇÕES", value: "information", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],

      expanded: [],

      items: [],

      loading: false,
      loadingExecute: false,
      loadingPay: false,
      loadingDelete: false,

      errors: [],
    };
  },

  created() {
    for (let i = 1; i <= 27; i++) {
      this.daily_amounts.push({ value: i, description: i });
    }

    this.parcel_numbers.push({ value: "", description: "SELECIONE..." });

    for (let i = 1; i <= 14; i++) {
      this.parcel_numbers.push({
        value: i,
        description: `${i} ${i == 1 ? "PARCELA" : "PARCELAS"}`,
      });
    }
  },

  methods: {
    formatValueOnKeyUp,

    handleInputType(value) {
      this.items = [];
      this.number_of_installments = "";
      this.daily_amount = 1;
      if (value == "DIARIA") {
        this.handleTotalValueDaily();
      }
    },

    handleTotalValueDaily() {
      let { value, daily_amount } = this;

      if (daily_amount && value) {
        this.total_daily_value = daily_amount * numbersOnly(value);
      }
    },

    handleValueDailyAmount() {
      this.handleTotalValueDaily();
    },

    handleValueDaily(value) {
      this.value = formatValueOnKeyUp(numbersOnly(value));
      this.items.map((item) => (item.value = this.value));
      this.handleTotalValueDaily();
    },

    handleInputDueDate(due_date) {
      if (due_date) {
        if (this.items.length > 0) {
          this.items.map(
            (item, key) =>
              (item.due_date =
                key == 0
                  ? due_date
                  : moment(due_date).add(key, "months").format("YYYY-MM-DD"))
          );
        }
      }
    },

    handleValueNumberOfInstallments(value) {
      if (value) {
        let items = [];

        let { due_date } = this;

        for (let i = 1; i <= parseInt(value); i++) {
          items.push({
            value: this.value,
            due_date: due_date
              ? i == 1
                ? due_date
                : moment(due_date)
                    .add(i - 1, "months")
                    .format("YYYY-MM-DD")
              : "",
            note: "",
          });
        }
        this.items = items;
      } else {
        this.items = [];
      }
    },

    async execute() {
      try {
        this.loadingExecute = true;

        let {
          resident_id,
          type, // MENSAL|DIARIA
          number_of_installments, // Quantidade de parcelas
          value, // Valor da mensalidade/diária
          daily_amount, // Quantidade de diárias
          due_date, //  type == 'DIARIA' ? 'Vencimento da mensalidade' : 'Vencimento da 1ª mensalidade';
          items, // Parcelas - MENSAL
          total_daily_value,
        } = this;

        let params = {
          resident_id,
          type,
          number_of_installments,
          value,
          daily_amount,
          due_date,
          items,
          total_daily_value: formatValueOnKeyUp(String(total_daily_value)),
        };

        const response = await api.post(
          "/rest-home/resident-accommodation",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
          this.items = [];
          this.type = "MENSAL";
          this.value = "";
          this.daily_amount = 1;
          this.total_daily_value = 0;
          this.number_of_installments = "";
          this.due_date = "";
        } else {
          this.errors = errors;
        }

        this.loadingExecute = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>